import { getInternalAuthToken } from '@/custom/classes/my_utils.js'

export function globalAuthGuard (to, from, next) {
  const publicRoutes = ['login']
  if (!publicRoutes.includes(to.name) && !getInternalAuthToken()) {
    next({ name: 'login' })
  } else {
    next()
  }
}
